var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlinedStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66354 3.00591C8.80109 2.7272 9.19859 2.7272 9.33614 3.00591L11.1168 6.61394C11.1714 6.72462 11.277 6.80133 11.3992 6.81908L15.3808 7.39766C15.6884 7.44235 15.8112 7.82034 15.5887 8.03729L12.7075 10.8457C12.6191 10.9319 12.5788 11.056 12.5996 11.1777L13.2798 15.1432C13.3323 15.4496 13.0108 15.6832 12.7357 15.5386L9.17436 13.6663C9.06509 13.6088 8.93459 13.6088 8.82531 13.6663L5.264 15.5386C4.98889 15.6832 4.66735 15.4496 4.71989 15.1432L5.40005 11.1777C5.42091 11.056 5.38058 10.9319 5.2922 10.8457L2.41102 8.03729C2.18845 7.82034 2.31127 7.44235 2.61885 7.39766L6.60054 6.81908C6.72269 6.80133 6.82827 6.72462 6.88289 6.61394L8.66354 3.00591Z",
    stroke: "#8800FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedStar);
export default __webpack_public_path__ + "static/media/outlinedStar.118b4620.svg";
export { ForwardRef as ReactComponent };